import React from 'react';

class AuthErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null,
            errorInfo: null 
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log the error for debugging
        console.error('Auth Error Boundary caught an error:', error, errorInfo);
        
        // Clear any persisted auth state that might be causing issues
        localStorage.removeItem('mfa_challenge_active');
        
        // Store error info for display
        this.setState({
            error,
            errorInfo
        });
    }

    handleRestart = () => {
        // Clear error state and reload the page
        this.setState({ hasError: false, error: null, errorInfo: null });
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    padding: '2rem',
                    textAlign: 'center',
                    fontFamily: 'Montserrat, sans-serif'
                }}>
                    <div style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '16px',
                        padding: '2rem',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #e2e8f0',
                        maxWidth: '400px',
                        width: '100%'
                    }}>
                        <h2 style={{
                            color: '#e74c3c',
                            fontSize: '24px',
                            fontWeight: '700',
                            marginBottom: '1rem'
                        }}>
                            Authentication Error
                        </h2>
                        
                        <p style={{
                            color: '#64748b',
                            fontSize: '16px',
                            marginBottom: '1.5rem',
                            lineHeight: '1.5'
                        }}>
                            Something went wrong during the authentication process. 
                            This might be a temporary issue.
                        </p>
                        
                        <button 
                            onClick={this.handleRestart}
                            style={{
                                backgroundColor: '#425a76',
                                color: 'white',
                                padding: '12px 24px',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '16px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                minHeight: '44px'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#405238';
                                e.target.style.transform = 'translateY(-1px)';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = '#425a76';
                                e.target.style.transform = 'translateY(0)';
                            }}
                        >
                            Restart Login
                        </button>
                        
                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <details style={{
                                marginTop: '1rem',
                                textAlign: 'left',
                                fontSize: '12px',
                                color: '#64748b'
                            }}>
                                <summary style={{ cursor: 'pointer', marginBottom: '0.5rem' }}>
                                    Error Details (Development)
                                </summary>
                                <pre style={{
                                    backgroundColor: '#f8fafc',
                                    padding: '0.5rem',
                                    borderRadius: '4px',
                                    overflow: 'auto',
                                    fontSize: '11px'
                                }}>
                                    {this.state.error.toString()}
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </details>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default AuthErrorBoundary;